// @ts-nocheck
import { updateShippingNotification } from "@store/Framework/Services/Pages/OrderDetails/TrackingInfoService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type SetShippingNotificationParameter = {
    erpOrderNumber: string;
    newEmailNotificationsState: boolean;
    newNotificationsEmail: string;
};

type HandlerType = ApiHandler<SetShippingNotificationParameter, boolean>;

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await updateShippingNotification(
        props.parameter.erpOrderNumber,
        props.parameter.newEmailNotificationsState,
        props.parameter.newNotificationsEmail,
    );
};

export const DispatchCompleteSetShippingNotification: HandlerType = props => {
    const { dispatch, apiResult } = props;
    if (apiResult) {
        dispatch({
            type: "Store/Pages/OrderDetails/ShippingNotificationCompleted",
            newEmailNotificationsState: props.parameter.newEmailNotificationsState,
            newNotificationsEmail: props.parameter.newNotificationsEmail,
        });
    } else {
        dispatch({
            type: "Store/Pages/OrderDetails/ShippingNotificationFailed",
        });
    }
};

export const chain = [RequestDataFromApi, DispatchCompleteSetShippingNotification];

const setShippingNotification = createHandlerChainRunner(chain, "SetShippingNotification");
export default setShippingNotification;
